export default __webpack_public_path__ + "static/14-7596998be565af7ea02932c119eea9d7.jpg";